import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-trigger.module.scss.js';

const PageTrigger = () => {
  useLabel();
  const {
    open
  } = useLlmView(state => state.actions);
  return jsx("button", {
    type: "button",
    className: getClassNames(style.trigger, '-trigger'),
    onClick: () => open(),
    "aria-label": "Open assistant",
    children: jsx("div", {
      className: style.icon
    })
  });
};

export { PageTrigger };
//# sourceMappingURL=page-trigger.js.map
